
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18.01 18.01"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.78 8.233a.771.771 0 100 1.542h16.448a.771.771 0 000-1.542z","font-family":"sans-serif","overflow":"visible"}})])
          )
        }
      }
    